import React, { useEffect, useRef, useState } from 'react';
import Api from 'helpers/Api';
import { buildSearchParams, useQuery } from 'helpers/Url';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { Alert, Button, Table } from 'react-bootstrap';
import { useAuthDataContext } from 'providers/Auth';

import GroupOptions from 'components/pages/depots_groups/partials/Options';
import Options from './partials/Options';

import Question from 'components/modals/Question';
import Filter from './partials/Filter';
import AddOrEdit from './partials/AddOrEdit';
import Layout from 'components/layout/Layout';
import AddOrEditGroup from 'components/pages/depots_groups/partials/AddOrEdit';

//misc
import MenuOptions from 'components/misc/MenuOptions'
import Pagination from 'components/misc/Pagination'
import Loader from 'components/misc/Loader';
import NoDataFound from 'components/misc/NoDataFound';

let timeout;

function Index() {

    const location = useLocation();
    const history = useNavigate();
    const query = useQuery();
    const auth = useAuthDataContext();

    const addOrEditGroupModalRef = useRef(null);
    const addOrEditModalRef = useRef(null);
    const deleteModalRef = useRef(null);

    const [state, setState] = useState({
        loading: true,
        refresh: false,
        setFilter: false,
        data: [],
        pages: 0,
        total: 0,
        filter: {
            page: 1,
        },
    });

    useEffect(() => {
        setState(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                page: query.get('page') || 1,
                search: query.get('search') || ''
            },
            refresh: new Date().getTime()
        }))
    }, [location.search]);

    useEffect(() => {
        if (state.setFilter) {
            history('?' + buildSearchParams(query, state.filter));
        }

    }, [state.setFilter]);

    useEffect(() => {
        if (state.refresh) {
            loadData();
        }
    }, [state.refresh]);

    useEffect(() => {
        refresh();
    }, [auth.getUser()?.getStoreId()]);

    const loadData = () => {

        loading(true);

        let url = 'depots/all';

        Api.get(url, {
            params: state.filter
        }).then(res => {
            setState(prev => ({
                ...prev,
                data: res.data.items,
                total: res.data.total,
                pages: res.data.pages
            }));

            if (res.data.pages > 0 && state.filter.page > res.data.pages) {
                return handlePage({ selected: res.data.pages - 1 });
            }

            loading(false);

        });
    }

    const loading = (loading) => {
        setState(prev => ({
            ...prev,
            loading: Boolean(loading)
        }));
    }

    const refresh = (reset = true) => {
        setState(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                page: reset ? 1 : prev.filter.page
            },
            setFilter: new Date().getTime(),
            refresh: new Date().getTime(),
        }));
    }

    const handleAddGroup = () => {
        let modal = addOrEditGroupModalRef.current;

        modal.add();

        modal.onSuccess(() => {
            refresh(true);
        });
    }

    // update
    const handleEditGroup = id => {
        let modal = addOrEditGroupModalRef.current;

        modal.edit(id);

        modal.onSuccess(() => {
            refresh(false);
        });
    }

    // delete
    const handleDeleteGroup = id => {
        let modal = deleteModalRef.current;

        modal.open();
        modal.onSuccess(() => {
            handleDestroyGroup(id);
        })
    }

    const handleDestroyGroup = id => {
        Api.post('depots/groups/delete', {
            id: id
        }).then(res => {
            if (res.data.success) {
                refresh(false);
            }
        });
    }

    const handleAdd = (groupId) => {
        let modal = addOrEditModalRef.current;

        modal.add(groupId);

        modal.onSuccess(() => {
            refresh(true);
        });
    }

    // update
    const handleEdit = id => {
        let modal = addOrEditModalRef.current;

        modal.edit(id);

        modal.onSuccess(() => {
            refresh(false);
        });
    }

    // delete
    const handleDelete = id => {
        let modal = deleteModalRef.current;

        modal.open();
        modal.onSuccess(() => {
            handleDestroy(id);
        })
    }

    const handleDestroy = id => {
        Api.post('depots/delete', {
            id: id
        }).then(res => {
            if (res.data.success) {
                refresh(false);
            }
        });
    }


    // Search
    const handleSearch = (key, val, delay = 300) => {
        clearTimeout(timeout);

        setState(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                [key]: val,
            },
        }));

        timeout = setTimeout(() => {
            setState(prev => ({
                ...prev,
                filter: {
                    ...prev.filter,
                    page: 1
                },
                setFilter: new Date().getTime()
            }));
        }, delay);
    }

    const handlePage = page => {
        setState(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                page: page.selected + 1,
            },
            setFilter: new Date().getTime()
        }));
    }

    return (
        <>

            <AddOrEditGroup
                ref={addOrEditGroupModalRef}
            />

            <AddOrEdit
                ref={addOrEditModalRef}
                refresh={refresh}
            />

            <Question
                ref={deleteModalRef}
                mainMessage="Сигурни ли сте?"
                agreeBtnText="Изтриване"
                agreeBtnClass="remove"
            />

            <Layout>
                <div className="container-fluid">

                    <div className="page-head">
                        <h1 className="display-6">
                            Складове
                        </h1>

                        <div className="buttons">
                            <Button variant="outline-dark" onClick={handleAddGroup} disabled={auth.getUser().permission('depots_edit') === false}>
                                Добави нова група
                            </Button>
                        </div>
                    </div>

                    <br />

                    <div className="panel">
                        <Filter
                            filter={state.filter}
                            handleSearch={handleSearch}
                        />

                        {state.loading
                            ?
                            <Loader />
                            :
                            state.data.length === 0 ?
                                <NoDataFound />
                                :
                                <>
                                    <Table responsive striped>
                                        <thead>
                                            <tr>
                                                <th className="id">ID</th>
                                                <th>Име</th>
                                                <th className="options">
                                                    Опции
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {state.data.map(c =>
                                                <React.Fragment key={'c-' + c.id}>
                                                    <tr

                                                    >
                                                        <td className="id">
                                                            {c.id}
                                                        </td>

                                                        <td>
                                                            <span className="link" onClick={e => handleEditGroup(c.id)}>
                                                                {c.name}
                                                            </span>
                                                        </td>

                                                        <td className="options">
                                                            <MenuOptions>
                                                                <GroupOptions
                                                                    data={c}
                                                                    handleAdd={handleAdd}
                                                                    handleEdit={handleEditGroup}
                                                                    handleDelete={handleDeleteGroup}
                                                                />
                                                            </MenuOptions>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={3} style={{ padding: 0 }}>
                                                            {c.depots.length === 0
                                                                ?

                                                                <Button
                                                                    size="sm"
                                                                    variant="outline-primary"
                                                                    className="m-3"
                                                                    onClick={e => handleAdd(c.id)}
                                                                >
                                                                    Добави склад към тази група
                                                                </Button>
                                                                :
                                                                <Table className="nested" striped hover>
                                                                    <thead>
                                                                        <tr>
                                                                            <th className="id">
                                                                                ID
                                                                            </th>
                                                                            <th>
                                                                                Име
                                                                            </th>
                                                                            <th className="text-center">Тежест</th>
                                                                            <th className="options">
                                                                                Опции
                                                                            </th>
                                                                        </tr>

                                                                    </thead>
                                                                    <tbody>
                                                                        {c.depots.map(d =>
                                                                            <tr
                                                                                key={'d-' + d.id}
                                                                            >
                                                                                <td className="id">
                                                                                    {d.id}
                                                                                </td>

                                                                                <td>
                                                                                    <span className="link" onClick={e => handleEdit(d.id)}>
                                                                                        {d.name}
                                                                                    </span>
                                                                                </td>

                                                                                <td className="text-center">
                                                                                    {d.priority}
                                                                                </td>

                                                                                <td className="options">
                                                                                    <MenuOptions>
                                                                                        <Options
                                                                                            data={d}
                                                                                            handleEdit={handleEdit}
                                                                                            handleDelete={handleDelete}
                                                                                        />
                                                                                    </MenuOptions>
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </Table>
                                                            }
                                                        </td>
                                                    </tr>
                                                </React.Fragment>
                                            )}
                                        </tbody>
                                    </Table>

                                    <Pagination
                                        className="mt-3"
                                        page={state.filter.page}
                                        pages={state.pages}
                                        total={state.total}
                                        handlePage={handlePage}
                                    />
                                </>
                        }

                    </div>
                </div>
            </Layout>
        </>
    )
}

export default Index;